<template>
    <div class="mt-5 mb-5">
        <b-alert show v-if="!canCreate" variant="warning">
            <div class="d-flex align-items-center">
                <b-icon icon="info-circle" class="mr-2"/>
                <span>Создание клинических мероприятий невозможно, т.к. животное в данный момент не находится на содержании или содержится в другой организации.</span>
            </div>
        </b-alert>
        <data-table ref="events"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :initial-filters="initialFilters"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key"
                    :destroy-title="'Удаление мероприятия'"
                    :context-menu-wrapper-id="''"
                    @object-delete-success="onClinicalEventDeleted">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable.vue";
import api from "@/api";
import {mapGetters} from "vuex";
import {eventFactory, EventKind, EventKindLabel} from "@/pages/AppPages/Events/event";
import {Action, AvailableAction} from "@/components/Table/actions";
import store from "@/store";


// TODO: mixin для списков мероприятий

export default {
    name: "ClinicalEventList",
    components: {DataTable},
    props: {
        animal: { type: Object, default: () => { return {} } },
    },
    data() {
        const name = 'clinical-events-table';
        let columns = [];

        columns.push({ name: 'id', 'title': 'Номер',
            to: {
                idColumn: 'id',
                routeName: 'eventDetail',
                prependWithN: true
            },
            alwaysVisible: true,
            extraDataFrom: 'kind_name'
        });

        columns.push(
            { name: 'executor_contractor_name', 'title': 'Организация', extraDataFrom: 'executor_contract_number'},
            { name: 'attributes.conclusion', 'title': 'Заключение'},
            { name: 'attributes.vetSpecialist', 'title': 'Ветеринарный специалист'},
            { name: 'executor_name', 'title': 'Провел'},
            { name: 'execution_date', 'title': 'Проведено',
                    cellComponentName: 'DateTimeCell',
                    cellComponentPath: 'src/pages/DataTableCells/'},
            { name: 'created_at', 'title': 'Создано',
                    cellComponentName: 'DateTimeCell',
                    cellComponentPath: 'src/pages/DataTableCells/'},
        );

        return {
            table: {
                name: name,
                apiViewSet: api.events.default,
                key: name,
                search: true,
                columns: columns,
                orderings: [
                    'id',
                    { 'created_at_date_only': 'created_at' },
                    { 'execution_date_only': 'execution_date' },
                ],
                actions: [],
                rowActions: [],
                filters: [],
                initialFilters: {},
                initialOrderings: { id: 2 }
            }
        }
    },
    computed: {
        ...mapGetters(['ability', 'userOrganizationId', 'isShelter', 'isSuperuser']),
        backendApiRoute() {
            return api.events.default.list()
        },
        clinicalEventKinds() {
            return [EventKind.INITIAL, EventKind.SURVEY,
                EventKind.CLINICAL, EventKind.STERILIZATION,
                EventKind.VACCINATION,EventKind.MARKING
            ]
        },
        initialFilters() {
            return {  'animal': this.animal.id, 'kind': this.clinicalEventKinds };
        },
        canCreate() {
            let canCreate = this.ability.can('create', 'ClinicalEvent');
            // PETS-280: приют может создавать клинические мероприятия только если животное содержится в нем
            if (this.isShelter) {
                const isKept = this.animal.isKept;  // перестраховываюсь)
                const isKeptInUserShelter = this.animal.keepingPlaceId ? this.animal.keepingPlaceId === this.userOrganizationId : false;
                canCreate = canCreate && isKept && isKeptInUserShelter;
            }
            return canCreate
        }
    },
    methods: {
        onClinicalEventDeleted() {
            this.$emit('on-event-deleted')
        }
    },
    mounted() {
        const vm = this;
        let canCreate = this.canCreate;
        if (canCreate) {
            let createAction = null;
            let dropdownList = [];

            for (let i = 0; i < this.clinicalEventKinds.length; i++) {
                const kind = this.clinicalEventKinds[i];
                const text = EventKindLabel[kind][0];
                const route = {name: 'eventCreate', params: {animalId: vm.animal.id, kind: kind}};
                dropdownList.push({text: text, route: route})
            }

            createAction = new Action({
                name: 'createWithContext',
                icon: 'plus',
                class: 'btn-primary',
                title: 'Добавить',
                showTitle: false,
                dropdownList: dropdownList,
                emittedEvent: 'on-create',
                available: canCreate
            }, (choice) => {
                vm.$router.push(choice.route)
            });
            this.table.actions.push(createAction);
        }

        if (this.ability.can('destroy', 'ClinicalEvent')) {
            const destroyAction = new AvailableAction({ title: 'Удалить', icon: 'trash', emittedEvent: 'on-delete' }, (id, row) => {
                const objectClass = eventFactory(row['kind']);
                const object = new objectClass();
                object.applyData(row);
                return object
            }, (row) => {
                const objectClass = new eventFactory(row['kind']);
                const object = new objectClass();
                object.applyData(row);
                return store.getters.ability.can('destroy', object);
            })
            this.table.rowActions.push(destroyAction);
        }
    }
}
</script>

<style scoped>

</style>